<template>
    <transition name="show">
    <section class="popup">
        <div class="popup__content">
            <router-link to="/" class="close-popup"><i class="material-icons">close</i></router-link>
            <div class="contact">
                <!-- <p>Jednoduše nám napište nebo zavolejte</p> -->
                <p>Jednoduše nám zavolejte na</p>
                <h1>+420 602 879 396</h1>
                <!-- <h1>prodam@mojerestituce.cz</h1> -->
            </div>
        </div>
    </section>
    </transition>
</template>


<script>
export default {
  name: 'popup',
}
</script>

<style lang="stylus" scoped>

    .popup
        position fixed
        top: 0
        left: 0
        width: 100%
        height: 100%
        z-index: 10
        background-color: alpha(#000, .3)
        padding: 5%
        box-sizing: border-box
        display: flex
        justify-content: center
        align-items: center

    .popup__content
        display: flex
        align-items: center
        position: relative
        width: 100%
        max-width 80em
        height: 100%
        background-color: white
        border-radius: 4px
        padding: 4em
        box-sizing: border-box
        overflow: hidden
        box-shadow: 0 2px 10px alpha(#000, .3)

        &::before
            content: ""
            position: absolute
            right: 0
            bottom: 0
            display: inline-block
            width: 0
            height: 0
            border-style: solid
            border-width: 0 0 30em 30em
            border-color: transparent transparent #6980fe transparent

        .close-popup
            font-family: 'Material icons'
            position: absolute
            right: .7em
            top: .3em
            font-size: 2.2em
            margin 0

        .contact
            position: relative
            z-index: 3
        p
            color: #dcdcdc
            font-size: 3em
            margin: 0 0 1em 0
        h1
            font-size: 3em
            margin: 0

</style>



// WEBPACK FOOTER //
// src/components/Popup.vue